import axios from 'axios';

const API_URL = process.env.VUE_APP_HOST + '/api/data'; // Replace with your actual API URL

let access_token = "";

let auth = localStorage.getItem('session-authorization');

if (!auth) {
    access_token = process.env.VUE_APP_TOKEN;
    if (!access_token) {
        console.log(window.location.hash)
        var queries = window.location.hash.split("access_token=")
        if (queries.length > 1) {
            access_token = queries[1].split("&")[0]
            if (access_token) {
                let auth = "{\"access_token\":\"" + access_token + "\",\"token_type\":\"\Bearer\",\"expires_in\":\"3600\"}";
                localStorage.setItem('session-authorization', auth);
            }
        }
    }
}
else {
    access_token = JSON.parse(auth).access_token;
}

let headers = {
    headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
    }
};


export const dataApi = {
    fetchData: async (type, page, pageSize, filters) => {
        const response = await axios.get(`${API_URL}/${type}`, {
            params: {
                page,
                pageSize,
                searchQuery: filters.searchQuery,
                school: filters.school,
                department: filters.department,
                moduleCode: filters.moduleCode
            },
            headers: {
                'Authorization': `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    },

    createItem: async (type, item) => {
        const response = await axios.post(`${API_URL}/${type}`, item, headers);
        return response.data;
    },

    updateItem: async (type, id, item) => {
        const response = await axios.put(`${API_URL}/${type}/${id}`, item, headers);
        return response.data;
    },

    deleteItem: async (type, id) => {
        const response = await axios.delete(`${API_URL}/${type}/${id}`, headers);
        return response.data;
    },

    fetchSchools: async () => {
        const response = await axios.get(`${API_URL}/schools?page=1&pageSize=999`, headers);
        return response.data.items;
    },

    fetchDepartments: async () => {
        const response = await axios.get(`${API_URL}/departments?page=1&pageSize=9999`, headers);
        return response.data.items;
    },

    fetchModules: async () => {
        const response = await axios.get(`${API_URL}/modules?page=1&pageSize=9999`, headers);
        return response.data.items;
    },

    fetchStaff: async () => {
        const response = await axios.get(`${API_URL}/staff?page=1&pageSize=9999`, headers);
        return response.data.items;
    },
    uploadStaffImage: async (id, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axios.post(`${API_URL}/upload-staff-image/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${access_token}`
            }
        });
        return response.data;
    },
}